import { ETransactionType } from '../types/entities/transactions';

const mapTransTypesToUrlNames = (transType: ETransactionType) => {
    switch (transType) {
        case ETransactionType.PULSA:
            return 'pulsa';
        case ETransactionType.WITHDRAW:
            return 'withdraw';
        case ETransactionType.TOP_UP:
            return 'top-up';
        default:
            return '';
    }
};

export default mapTransTypesToUrlNames;
